import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import config from 'scoreboard/components/config'
import globals from 'scoreboard/components/globals'
import _ from 'lodash'

function getFullTitle(pageTitle) {
	let title = _.trim(pageTitle)
	if (config.development) {
		let dbLabel = _.get(globals, 'database.label')
		if (dbLabel) {
			title += ' (' + _.trim(globals.database.label) + ')'
		}
	} else {
		title += ' - ' + i18n.get('app.name')
	}
	return title
}

function setupTitles() {
	Backbone.on('pageTitle', pageTitle =>
		document.title = getFullTitle(pageTitle))
}

export default setupTitles

setupTitles.__filename__ = 'setup-titles.js'
